import { AclAssetOrChildResourceType } from '@y42/acl/models';
import { assertNonNullable } from '@y42/util/assert';
import {
  Asset,
  isFeatureChildUIModel,
  isFeatureUIModel,
  Y42FeatureToAclAssetChildResourceType,
  Y42FeatureToAclAssetResourceType,
} from '../models';

export function getAclResourceTypeFromAsset(asset: Asset): AclAssetOrChildResourceType {
  const aclResourceType = isFeatureUIModel(asset)
    ? Y42FeatureToAclAssetResourceType[asset.featureType]
    : isFeatureChildUIModel(asset)
    ? Y42FeatureToAclAssetChildResourceType[asset.featureType]
    : null;

  assertNonNullable(aclResourceType);

  return aclResourceType;
}
